import React from "react";
import CardLayout from "../../../../common/cardLayout/CardLayout";
import BillingNotesTable from "./BillingNotesTable";
import PatientLoader from "../../../../common/PatientLoader";
import { NoAssessments } from "../FlaggedJournals";
import { useSelector } from "react-redux";
import moment from "moment";
import { getFullName } from "../../../../../util/helpers";

export const BillingNotesPDFComponent = ({ showTitle = true,pdfData  }) => {
  const { patientNotes, patientNotesLoading } = useSelector(
    (state) => state.patient
  );
  const { staffData } = useSelector((state) => state.app);
  let billingData = null;
  if(pdfData){
    billingData = pdfData.filter(note => note.activity !== null && note.activity !== '');
  }else {
    billingData = patientNotes.filter(note => note.activity !== null && note.activity !== '');
  }
  //const billingdData = patientNotes.filter(note => note.activity !== null && note.activity !== '');
  const getManagedBy = (id) => {
    const added_by_staff = staffData?.find((staff) => {
      if (staff?.id === id) {
        return staff;
      }
    });
    return getFullName(added_by_staff) || "Not available";
  };

  return (
    <CardLayout
      className="container-fluid"
      style={{ margin: "0px", padding: "0px" }}
    >
      {showTitle && (
        <div className="container-fluid d-flex">
          <label style={{ fontSize: "1.3rem" }}>Billing Notes</label>
        </div>
      )}

      {patientNotesLoading ? (
        <PatientLoader />
      ) : (
        <table className="table px-2">
          <thead className="thead-light" style={{ backgroundColor: "#F9FAFB" }}>
            <tr
              style={{
                height: "4rem",
                verticalAlign: "middle",
              }}
            >
              <th scope="col">
                <span className="muted-text">Date Created</span>
              </th>
              <th scope="col">
                <span className="muted-text">Billing Month</span>
              </th>
              <th scope="col">
                <span className="muted-text">Creator</span>
              </th>
              <th scope="col">
                <span className="muted-text">Activity</span>
              </th>
              <th scope="col">
                <span className="muted-text">Duration</span>
              </th>
              <th scope="col">
                <span className="muted-text">Note</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {billingData?.map((notes) => {
              return (
                <tr
                  key={notes?.id}
                  className="py-3"
                  style={{
                    height: "4rem",
                    verticalAlign: "middle",
                  }}
                >
                  <td>
                    <small style={{ fontWeight: "500" }}>
                      {moment(notes?.created).format("MMM DD, YYYY") ||
                        "Not Available"}
                    </small>
                  </td>
                  <td>
                    <small style={{ fontWeight: "500" }}>
                      {(notes?.month) ||
                        "Not Available"}
                    </small>
                  </td>
                  <td>
                    <small style={{ fontWeight: "500" }}>
                      {getManagedBy(notes?.added_by) || "-"}
                    </small>
                  </td>
                  <td>
                    <small style={{ fontWeight: "500" }}>
                      {notes?.activity || "-"}
                    </small>
                  </td>
                  <td>
                    <small style={{ fontWeight: "500" }}>
                      {notes?.duration || "-"}
                    </small>
                  </td>
                  <td>
                    <small style={{ fontWeight: "500" }}>
                      {notes?.notes || "-"}
                    </small>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </CardLayout>
  );
};

const BillingNotes = (props) => {
  const { patientNotes, patientNotesLoading } = useSelector(
    (state) => state.patient
  );
  const billingdData = patientNotes.filter(note => note.activity !== null && note.activity !== '');
    let filteredBillingData = null
  const filterMonthYear = moment(props?.billingNotesFilter).format("MMMM YYYY");
  if(props.billingNotesFilter){
  
  filteredBillingData = billingdData.filter(note => {
    return moment(note.month).format("MMMM YYYY") === filterMonthYear;
  });

  }else {
    filteredBillingData = billingdData
  }
  const totalDuration = filteredBillingData.reduce((total, item) => total + (item.duration || 0), 0);
  // console.log("billingNotesFilter",props.billingNotesFilter)
  // console.log("billingdData",billingdData)
  // console.log("filteredBillingData",filteredBillingData)
  // console.log("filterMonthYear",filterMonthYear)
  return (
    <CardLayout
      className="col-sm-12 col-md-12 col-lg-12"
      style={{
        border: "8px solid transparent",
        boxSizing: "border-box",
        backgroundClip: "padding-box",
      }}
    >
      <div className="container-fluid p-4">
        {props?.showTitle && (
          <div className="d-flex mb-4 mt-2">
            <label style={{ fontSize: "1.3rem" }}>Billing Notes</label>
          </div>
        )}

        <div className="container-fluid">
          {patientNotesLoading ? (
            <PatientLoader />
          ) : (
            <>
              {patientNotes.length === 0 ? (
                <NoAssessments
                  text="No notes for this patient!"
                  show_link={false}
                />
              ) : (
                <>
                <BillingNotesTable
                  startDate={props?.startDate}
                  endDate={props?.endDate}
                  data={filteredBillingData}
                  notesFilterValue={props?.billingNotesFilter}
                  notesDownloadMode={props?.notesDownloadMode}
                  setNotesDownloadMode={props?.setNotesDownloadMode}
                />
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <label>Total Duration: {totalDuration} minutes</label>
                </div></>
              )}
            </>
          )}
        </div>
      </div>
    </CardLayout>
  );
};
export default BillingNotes;
